// ── ChopMyShop Analytics ─────────────────────────────────────────────────────
// Thin wrappers around Firebase Analytics logEvent.
// All app-level tracking goes through here — easy to audit, easy to extend.

import { logEvent } from '../firebase';

// ── Screen views ─────────────────────────────────────────────────────────────
export const trackScreen = (screenName) =>
  logEvent('screen_view', { screen_name: screenName });

// ── Search ───────────────────────────────────────────────────────────────────
export const trackSearch = (term, resultCount) =>
  logEvent('search', { search_term: term, result_count: resultCount });

export const trackSearchMiss = (term) =>
  logEvent('search_miss', { search_term: term });

// ── Browse ───────────────────────────────────────────────────────────────────
export const trackAisleOpen = (aisleName) =>
  logEvent('aisle_open', { aisle: aisleName });

export const trackSubcategoryOpen = (subcategoryName) =>
  logEvent('subcategory_open', { subcategory: subcategoryName });

export const trackProductView = (productName, category) =>
  logEvent('product_view', { product_name: productName, category });

// ── List ─────────────────────────────────────────────────────────────────────
export const trackAddToList = (productName, category) =>
  logEvent('add_to_list', { product_name: productName, category });

export const trackListSaved = (itemCount) =>
  logEvent('list_saved', { item_count: itemCount });

export const trackListCleared = () =>
  logEvent('list_cleared');

// ── Compare ──────────────────────────────────────────────────────────────────
export const trackCompareOpen = (itemCount) =>
  logEvent('compare_stores_open', { item_count: itemCount ?? 0 });

// ── Use last shop ─────────────────────────────────────────────────────────────
export const trackUseLastShop = (matchedItemCount) =>
  logEvent('use_last_shop', { matched_item_count: matchedItemCount ?? 0 });

// ── Receipt ──────────────────────────────────────────────────────────────────
export const trackReceiptScanStart = (source) =>
  logEvent('receipt_scan_start', { source }); // source: 'camera' | 'library'

export const trackReceiptScanComplete = (matchedCount, itemCount) =>
  logEvent('receipt_scan_complete', { matched_count: matchedCount, item_count: itemCount });

// ── Auth ─────────────────────────────────────────────────────────────────────
export const trackSignIn = (method) =>
  logEvent('login', { method }); // method: 'google' | 'guest'

export const trackSignInPromptShown = (trigger) =>
  logEvent('sign_in_prompt_shown', { trigger });
